import React from 'react'
import Icons from '~/Common-Objects/UI/Icons/index'
import Select from '~/Common-Objects/UI/Forms/Select/Select'

export default function ColumnSelect({ data = [], value = [], onChange = () => {}, selectAll = false }) {
    const onSelect = (v) => {
        const arr = [...value]
        const index = arr.indexOf(v)
        if (index > -1) {
            arr.splice(index, 1)
        } else {
            arr.push(v)
        }
        onChange(arr)
    }

    return (
        <Select
            fixedHeader={<Icons icon='table' color='#7C8086' style={{ height: 25 }} />}
            multiple={true}
            data={data}
            align='right'
            autoWidth={true}
            hideIconRight={true}
            fixedHeightLarge={true}
            value={value}
            filter={true}
            selectAll={selectAll}
            clearAll={() => onChange([])}
            onChange={(e) => onSelect(e.target.value)}
        />
    )
}
